"use strict";

const yichen = require("./lib/bundle.js");
module.exports = yichen


